import { FlexColumn } from '@make-software/cspr-design';
import React from 'react';
import { OfferCreateForm } from 'app/components/management/apps/offers/create/offer-create-form';
import { PageContainer, StyledCaption } from 'app/components/common/common-styles';
import { useTabsCtx } from 'app/components/management/apps/tabs-page-layout';

export const OfferCreatePage: React.FC = () => {
  const { setBreadcrumbs } = useTabsCtx();

  React.useEffect(() => {
    setBreadcrumbs([
      {
        label: 'Create new'
      }
    ]);
    return () => setBreadcrumbs([]);
  }, []);

  return (
    <PageContainer>
      <FlexColumn justify={'center'} align={'center'}>
        <StyledCaption />
        <OfferCreateForm />
      </FlexColumn>
    </PageContainer>
  );
};
